<template>
	<StandardModal
		open
		:title="$t('settings_edituser_welcomemessage')"
		:confirmText="$t('common_button_send')"
		:confirmProps="{ loading }"
		@confirm="send"
		@cancel="close"
		small
		ref="modal"
		class="send-welcome-modal"
	>
		<div class="modal-wrapper">
			<PaperAirplaneIcon halo />
			{{ $t('admin_people_welcome_message_confirm_longer') }}
		</div>
	</StandardModal>
</template>

<script>
import { StandardModal } from '@/components/common'
import { PaperAirplaneIcon } from '@/icons'
import { patch } from '../common'

export default {
	name: 'SendWelcomeModal',
	components: { StandardModal, PaperAirplaneIcon },
	props: {
		user: Object,
	},
	data() {
		return { loading: false }
	},
	emits: ['welcomesent', 'close'],
	methods: {
		async send() {
			this.processingError = false
			this.loading = true
			try {
				const apiResponse = await patch(`/organization/users/${this.user.id}`, {
					send_welcome_message: true,
				})
				this.$emit('welcomesent', apiResponse.sentwelcomemsg)
				this.$alert.success(this.$t('admin_people_welcome_message_sent_label'))
				this.close()
			} catch (e) {
				this.loading = false
				this.$refs.modal.$alert.error(this.$t('common_api_error_save'))
			}
		},
		close() {
			this.$emit('close')
		},
	},
}
</script>

<style lang="scss">
@import 'src/sass/variables';

.send-welcome-modal {
	.modal-wrapper {
		@include flex-column-center;
		max-width: 300px;
		margin: 24px auto;
		text-align: center;
		.pronto-icon {
			color: var(--blue-300);
			font-size: 50px;
			margin-bottom: 24px;
		}
	}
}
</style>
